import { useState, useEffect } from "react";
import { ScrollRestoration, useParams } from "react-router-dom";

import { PartDto } from "#modules/parts/infra/fetchPart.api";
import { AiLoader } from "#modules/similarPart/view/AiLoader";
import { PAGE_SIZE } from "#modules/similarPart/view/SearchResult";
import { SimilarPartSearchResultsPage } from "#modules/similarPart/view/SimilarPartSearchResults";
import { useAssembly } from "#modules/similarPart/view/useAssembly";
import { useDataChunkSize } from "#shared/helpers/useDataChunkSize";
import { useDelay } from "#shared/helpers/useDelay";
import { PageLayout } from "#shared/layouts/PageLayout";
import { useAnalytics, AnalyticsEvent } from "#shared/useAnalytics";

const MIN_TIMER_BEFORE_RENDERING = 1;

export const SimilarPartPage = () => {
  const [part, setPart] = useState<PartDto | null>(null);
  const { partId: defaultPartId } = useParams();
  const analytics = useAnalytics();

  useEffect(() => {
    analytics.capture(AnalyticsEvent.SimilarPartPageViewed, { part_id: defaultPartId });
    // oxlint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const { assembly, isAssemblyLoading, isAssemblyAnalyzing } = useAssembly({
    part,
    setPart,
    defaultPartId,
  });

  const { dataChunkSize } = useDataChunkSize(PAGE_SIZE);

  const { isDelayElapsed: isRenderDelayElapsed } = useDelay(MIN_TIMER_BEFORE_RENDERING);

  if (!assembly || isAssemblyLoading || !isRenderDelayElapsed || !part) {
    return <AiLoader />;
  }

  return (
    <PageLayout>
      <SimilarPartSearchResultsPage
        assembly={assembly}
        part={part}
        dataChunkSize={dataChunkSize}
        setPart={setPart}
        isAssemblyAnalyzing={isAssemblyAnalyzing}
      />

      <ScrollRestoration getKey={(location) => location.pathname} />
    </PageLayout>
  );
};
